import styled from 'styled-components';
import themeColors from '../assets/styles/themeColors';
import { variables } from '../assets/styles/variables';

export const ReviewDataContainer = styled.div`
  display: flex;
  flex-direction: column;

  svg {
    cursor: pointer;
  }
`;

export const EditContainer = styled.span`
  cursor: pointer;
`;

export const PreviewContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TAndCLink = styled.a`
  all: unset;
  text-decoration: underline;
  cursor: pointer;
  padding-left: 4px;
  color: ${themeColors.colorTextGrey};
`;

export const FundingInfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 100%;
  padding: 20px 30px;
  background: ${themeColors.colorBackgroundSecondary};
  margin-top: 21px;
  border-radius: ${variables.borderRadius.borderRadius};

  @media only screen and (max-width: 500px) {
    padding: 20px;
  }
`;
export const FundType = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const InformationContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
